export const GenerateEmptyMonthStatements = (statements, dataObj) => {
    return statements && statements.map((statement) => {
        let obj: any = { ...dataObj };
        obj.calendaryear = Number(statement.statementYear);
        obj.calendarmonth = Number(statement.statementMonth);
        return obj;
    });
};

export const GenerateEmptyMonthStatementsForAccount = (statements, dataObj) => {
    return statements && statements.map((statement) => {
        let obj: any = { ...dataObj };
        obj.calendarYear = Number(statement.statementYear);
        obj.calendarMonth = Number(statement.statementMonth);
        return obj;
    });
};